import React from 'react';
import MaterialIcon from './MaterialIcon';

const renderIcon = (icon) => {
    if (typeof icon === 'string') return <MaterialIcon name={icon} size={32} className="text-secondary" />;
    if (icon) {
        const Icon = icon;
        return <Icon className="w-8 h-8 text-secondary" />;
    }
    return <MaterialIcon name="inbox" size={32} className="text-secondary" />;
};

const EmptyState = ({ icon = 'inbox', title = 'Nothing here yet', body = '', children }) => (
    <div className="flex flex-col items-center justify-center py-16 sm:py-20 px-6 text-center">
        <div className="w-16 h-16 bg-section-bg rounded-2xl flex items-center justify-center mb-6 warm-tactile-shadow">
            {renderIcon(icon)}
        </div>
        <h3 className="text-xl font-bold text-primary-dark mb-2">{title}</h3>
        {body && <p className="text-sm font-medium text-slate-500 max-w-sm mb-8 leading-relaxed">{body}</p>}
        {children}
    </div>
);

export default EmptyState;
